// module.exports = (file, path) => {
//     if (!path) path = 'page'
//     return require(`../${path}/${file}.vue`)
// }
//按需加载路由
module.exports = (file, path) => {
  if (!path) path = "page";
  let chunkName = file.split("/")[0] ? file.split("/")[0] : "default";
  return r => require.ensure([],() => r(require(`../${path}/${file}.vue`)),() => {return chunkName;});
};
